import React, { ReactElement, ReactNode } from "react";
import mixopiaIcon from "../images/MIXOPIA_ICON_RGB.svg";
import { Track } from "./EventModel";

interface TrackProps {
  right?: ReactNode;
  track: Track;
}

const TrackDetails = (
  props: React.PropsWithChildren<TrackProps>
): ReactElement => (
  <div>
    <div className="app-track-details d-flex align-items-center">
      <div className="me-3"><img height="72" src={props.track.imageUrl || mixopiaIcon} alt="artwork" /></div>
      <div className="flex-fill">
        <h5 className="mb-0">
          {props.track.name}
        </h5>
        <span className="body-copy-2">{props.track.artist}</span>
      </div>
      {props.right && <div className="ms-auto">{props.right}</div>}
    </div>
    <div className="app-media-children">{props.children}</div>
  </div>
);
export default TrackDetails;
